import { formatDate } from '@if/core/utils'
import { DataField, StrongValue } from '@if/mui'
import { Grid } from '@mui/material'
import { useMerchantById } from '@src/data/api/merchants-api/merchants-api'
import { calculateDaysUntilExpiration } from '@src/services/Formatter'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { Calendar, CalendarClock, Store, User } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: CreditApplication
}

const LoanInfoBox = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [merchant] = useMerchantById(creditApp.merchantId)
  const daysUntilExpiration = calculateDaysUntilExpiration(creditApp.expiresOn)
  const expiration =
    daysUntilExpiration < 0
      ? t('viewCreditApplication.expired')
      : `${daysUntilExpiration} ${daysUntilExpiration <= 1 ? t('common.day') : t('common.days')}`

  const fields = [
    { icon: Store, label: t('viewCreditApplication.merchant'), value: merchant?.name ?? '' },
    { icon: User, label: t('viewCreditApplication.createdBy'), value: creditApp.createdByUserFullName },
    { icon: Calendar, label: t('viewCreditApplication.createdOn'), value: formatDate(creditApp.createdOn) },
    {
      icon: CalendarClock,
      label: t('viewCreditApplication.expiresOn'),
      value: `${formatDate(creditApp.expiresOn)} (${expiration})`,
    },
  ]

  return (
    <Grid container spacing={2}>
      {fields.map((field) => (
        <Grid key={field.label} size={{ xs: 12, sm: 6, lg: 3 }}>
          <DataField
            icon={field.icon}
            label={field.label}
            labelVariant="eyebrow"
            value={<StrongValue>{field.value}</StrongValue>}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default LoanInfoBox
